import React from "react";
import styled from "styled-components";
import {Grid} from "@material-ui/core";
import {DetailsInterface} from "../../../interface/challenge/details";
import {Skeleton} from "@material-ui/lab";
import {formatAddress, getBalanceNumber} from "../../../utils/formatBalance";
import {DateUtils} from "../../../utils/date";
import {AppConfig} from "../../../config";

export const DetailsWidget: React.FC<{ model?: DetailsInterface }> = ({model}) => {
    return (
        <DetailsStyle>

            <Grid container wrap={'wrap'} justify={"space-between"}>
                <CellWidget label={'Claimed By'} center={formatAddress(model?.cover_hash || '')}/>
                <CellWidget label={'Claim ID'} center={model?.claim_id}/>
                <CellWidget
                    label={'Claim period'}
                    center={model?.claim_begin_at ?
                        DateUtils.dataString(model?.claim_begin_at) + ' - ' + DateUtils.dataString(model?.claim_end_at) :
                        ''}
                />
                <CellWidget label={'Cover Amount'} center={getBalanceNumber(model?.amount || '') + " ETH"}/>
                <CellWidget label={'Cover Period'}
                            center={model?.cover_begin_at ? DateUtils.dataString(model?.cover_begin_at) +" - "+DateUtils.dataString(model?.cover_end_at) :
                                ''
                            }/>
                <CellWidget label={'Product'} center={model?.product}/>


                <CellWidget label={'Cost'}
                            center={getBalanceNumber(model?.cost || 0) +" ETH"}/>
                <CellWidget label={'Loss'}
                            center={model?.loss || ' '}/>
            </Grid>

            <DescriptionStyle >
               <span>Credentials:</span>
               <a href={AppConfig.IPFS_NONE +'/'+ model?.cred} target={'_back'}>
                   {model?.cred ? model.cred : <Skeleton variant="text" width={150} height={20}/>}
               </a>
            </DescriptionStyle>

            <DescriptionStyle style={{borderBottom: 'none'}}>
                <span>Description:</span><p>{model?.desc ? model.desc :
                <Skeleton variant="text" width={150} height={20}/>}</p>
            </DescriptionStyle>

        </DetailsStyle>
    );
}

const DescriptionStyle = styled.div`
  display: flex;
  padding-left: 20px;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #D8D8D8;

  span {
    width: 120px;
    display: block;
  }

  p {
    color: #666666;
  }
`


const CellWidget: React.FC<{ label: string, center?: any }> = ({label, center}) => {
    return (
        <CellStyle item md={6} xs={12} sm={6}>
            <div>
                <span>{label}: </span> {center ? center : <Skeleton variant="text" width={150} height={20}/>}
            </div>
        </CellStyle>
    );
}

const DetailsStyle = styled.div`
  box-sizing: border-box;
`

const CellStyle = styled(Grid)`

  &:nth-child(2n+2) {
    div {
      float: right;
    }
  }

  > div {
    border-bottom: 1px solid #D8D8D8;
    padding-left: 20px;
    box-sizing: border-box;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    align-items: center;
    height: 60px;
    width: 98%;

    span {
      width: 120px;
      display: block;
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      margin-right: 10px;
    }
  }
`
